/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFFindingRecordAPIResponse } from './CRSFFindingRecordAPIResponse';
import {
    CRSFFindingRecordAPIResponseFromJSON,
    CRSFFindingRecordAPIResponseFromJSONTyped,
    CRSFFindingRecordAPIResponseToJSON,
} from './CRSFFindingRecordAPIResponse';

/**
 * 
 * @export
 * @interface CRSFFindingsPagedResponse
 */
export interface CRSFFindingsPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFFindingsPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFFindingsPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFFindingRecordAPIResponse>}
     * @memberof CRSFFindingsPagedResponse
     */
    results?: Array<CRSFFindingRecordAPIResponse>;
    /**
     * 
     * @type {number}
     * @memberof CRSFFindingsPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFFindingsPagedResponse interface.
 */
export function instanceOfCRSFFindingsPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFFindingsPagedResponseFromJSON(json: any): CRSFFindingsPagedResponse {
    return CRSFFindingsPagedResponseFromJSONTyped(json, false);
}

export function CRSFFindingsPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFFindingsPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFFindingRecordAPIResponseFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFFindingsPagedResponseToJSON(value?: CRSFFindingsPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFFindingRecordAPIResponseToJSON)),
        'total': value.total,
    };
}

